/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type DataProvider,
    DataProviderFromJSON,
    DataProviderToJSON,
} from '../models/DataProvider';
import {
    type PaginatedDataProviderList,
    PaginatedDataProviderListFromJSON,
    PaginatedDataProviderListToJSON,
} from '../models/PaginatedDataProviderList';

export interface DataProvidersListRequest {
    company?: number;
    cursor?: string;
    dataSource?: Array<DataProvidersListDataSourceEnum>;
    hasData?: boolean;
    hasPublicData?: boolean;
    isEnabled?: boolean;
    ordering?: string;
}

export interface DataProvidersRetrieveRequest {
    id: string;
}

/**
 * 
 */
export class DataProvidersApi extends runtime.BaseAPI {

    /**
     * Creates request options for dataProvidersList without sending the request
     */
    async dataProvidersListRequestOpts(requestParameters: DataProvidersListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['company'] != null) {
            queryParameters['company'] = requestParameters['company'];
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['hasData'] != null) {
            queryParameters['has_data'] = requestParameters['hasData'];
        }

        if (requestParameters['hasPublicData'] != null) {
            queryParameters['has_public_data'] = requestParameters['hasPublicData'];
        }

        if (requestParameters['isEnabled'] != null) {
            queryParameters['is_enabled'] = requestParameters['isEnabled'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/data-providers/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve data provider information.
     */
    async dataProvidersListRaw(requestParameters: DataProvidersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDataProviderList>> {
        const requestOptions = await this.dataProvidersListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDataProviderListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve data provider information.
     */
    async dataProvidersList(requestParameters: DataProvidersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDataProviderList> {
        const response = await this.dataProvidersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dataProvidersRetrieve without sending the request
     */
    async dataProvidersRetrieveRequestOpts(requestParameters: DataProvidersRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling dataProvidersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/data-providers/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve data provider information.
     */
    async dataProvidersRetrieveRaw(requestParameters: DataProvidersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataProvider>> {
        const requestOptions = await this.dataProvidersRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataProviderFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve data provider information.
     */
    async dataProvidersRetrieve(requestParameters: DataProvidersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataProvider> {
        const response = await this.dataProvidersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const DataProvidersListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type DataProvidersListDataSourceEnum = typeof DataProvidersListDataSourceEnum[keyof typeof DataProvidersListDataSourceEnum];
